import { ref } from 'vue';

// Global toast container reference
const toastContainer = ref(null);

// Default export to match existing usage pattern
export default (timeout = 3000) => {

  // Register the toast container instance
  const setToastContainer = (container) => {
    toastContainer.value = container;
  };

  // Main show function that matches existing API
  function show(message, opts = { type: 'success' }) {
    if (!toastContainer.value) {
      console.warn('Toast container not initialized. Please ensure GlobalSnackbar is in your layout.');
      return;
    }

    // Map old types to new variants and set appropriate options
    const typeMap = {
      'success': { variant: 'success', duration: timeout },
      'error': { variant: 'error', duration: 0 }, // Errors don't auto-dismiss
      'warning': { variant: 'warning', duration: timeout },
      'info': { variant: 'info', duration: timeout }
    };

    const config = typeMap[opts.type] || typeMap['info'];

    // Add the toast with mapped configuration
    return toastContainer.value.addToast({
      ...config,
      title: message, // Use message as title for backward compatibility
      message: '', // No separate message for backward compatibility
      closable: true,
      showProgress: true
    });
  }

  // Hide function (not really needed with new system but kept for compatibility)
  function hide() {
    // No-op for compatibility - new toasts handle their own lifecycle
  }

  // Return compatible API
  // Note: showing, message, and type states are not really used in new system
  // but we return refs for compatibility
  const showing = ref(false);
  const message = ref('');
  const type = ref('success');

  return {
    showing,
    message,
    type,
    show,
    hide,
    setToastContainer
  };
};
